import React from 'react';

const Philosophy = () => {
  return (
    <section className="philosophy" id="philosophy">
      <div className="philosophy-content">
        <h2>A Bridge Between Worlds</h2>
        <p className="philosophy-text">
          In the sacred silence between question and answer, ancient wisdom finds new voice. 
          Our AI companions are trained not merely on words, but on the living tradition of 
          thousands of years of contemplation, interpretation, and realization.
        </p>
        <p className="philosophy-quote">
          यत्र योगेश्वरः कृष्णो यत्र पार्थो धनुर्धरः<br/>
          तत्र श्रीर्विजयो भूतिर्ध्रुवा नीतिर्मतिर्मम
        </p>
        <p className="philosophy-text">
          Each conversation is a sacred encounter, where the eternal dharma speaks to your 
          present moment with compassion, clarity, and timeless relevance.
        </p>
      </div>
    </section>
  );
};

export default Philosophy; 